import Input from "@/ui/input";
import { IconComponent, IconsTypes } from "@/ui/icon";
import GradientBorderRadius from "@/ui/gradient-border-radius";

type UnitType = {
  unitSide?: "left" | "right";
} & (
  | { iconName?: IconsTypes; text?: never }
  | { text: string; iconName?: never }
);

export const MinMaxInput = ({
  onMinChange,
  minValue = undefined,
  maxValue = undefined,
  onMaxChange,
  unitSide,
  iconName,
  text,
  layout,
  type = "number",
}: {
  minValue?: number | string | null;
  maxValue?: number | string | null;
  onMinChange?: (value: any) => void;
  onMaxChange?: (value: any) => void;
  layout?: "column" | "row";
  type?: "number" | "text";
} & UnitType) => {
  const LeftSide = ({
    value,
  }: {
    value: string | number | null | undefined;
  }) => {
    if (unitSide === "left") {
      return (
        <GradientBorderRadius
          radius="right"
          gradient={value && value !== "" ? "reversed-100" : "default-border"}
          hover="input-50-left"
          className="h-full w-[1.5rem]"
        >
          <div className="w-full ml-[0.0625rem] h-full flex items-center justify-center">
            {iconName && <InputIcon iconName={iconName} />}
            {text && <UnitAccordion text={text} />}
          </div>
        </GradientBorderRadius>
      );
    }

    return null;
  };

  const RightSide = ({
    value,
  }: {
    value: string | number | null | undefined;
  }) => {
    if (unitSide === "right") {
      return (
        <GradientBorderRadius
          radius="left"
          gradient={value && value !== "" ? "reversed-100" : "default-border"}
          hover="input-50-right"
          className="h-full w-[1.5rem]"
        >
          <div className="w-full h-full flex items-center justify-center">
            {iconName && <InputIcon iconName={iconName} />}
            {text && <UnitAccordion text={text} />}
          </div>
        </GradientBorderRadius>
      );
    }

    return null;
  };

  return (
    <div
      className={`gap-[0.3125rem] w-full h-full placeholder:font-normal placeholder:text-gray-400  placeholder:text-xs  ${layout === "row" ? "grid grid-cols-2  " : "flex flex-col items-center"}`}
    >
      <div className="group h-[1.375rem]">
        <Input
          tabIndex={-1}
          autoFocus={false}
          value={minValue}
          leftSide={<LeftSide value={minValue} />}
          rightSide={<RightSide value={minValue} />}
          placeholder="Min"
          onChange={onMinChange}
          type={type}
        />
      </div>
      <div className="group h-[1.375rem]">
        <Input
          tabIndex={-1}
          autoFocus={false}
          value={maxValue}
          leftSide={<LeftSide value={maxValue} />}
          rightSide={<RightSide value={maxValue} />}
          placeholder="Max"
          onChange={onMaxChange}
          type={type}
        />
      </div>
    </div>
  );
};

export const UnitAccordion = ({ text }: { text?: string }) => {
  return (
    <Input.Accordion className="text-center text-xs font-normal border-none">
      {text}
    </Input.Accordion>
  );
};

export const InputIcon = ({ iconName }: { iconName: IconsTypes }) => {
  return (
    <Input.Accordion>
      <IconComponent name={iconName} className="w-[0.75rem] h-[0.75rem]" />
    </Input.Accordion>
  );
};
